/* Le aggiunte all'ordine: catena, cordoncino, astuccio.
 *
 * Il modulo di acquisto del tema sa aggiungere una riga sola. Qui ne servono
 * due o tre, e non come varianti ma come prodotti distinti, ciascuno col suo
 * prezzo.
 *
 * Il modo meno invasivo è lasciare al tema il suo mestiere e infilarsi prima:
 * si intercetta l'invio del modulo, si mettono nel carrello le aggiunte, poi
 * si lascia partire l'invio vero, che aggiunge il prodotto e apre la notifica
 * del carrello come sempre. Nessuna riga del tema viene riscritta.
 *
 * L'ascolto sta sull'elemento <product-form>, non sul <form>: su uno stesso
 * elemento i gestori partono nell'ordine in cui sono stati registrati, e il
 * tema registra il suo per primo. Su un antenato invece la fase di cattura
 * arriva prima davvero, ed è l'unico punto in cui si può ancora fermare
 * l'invio.
 */

if (!customElements.get('aggiunte-prodotto')) {
  customElements.define(
    'aggiunte-prodotto',
    class AggiunteProdotto extends HTMLElement {
      connectedCallback() {
        // il modulo della propria sezione, non il primo della pagina: i
        // prodotti correlati in fondo ne hanno uno per scheda
        const sezione = this.closest('.shopify-section') || document;
        this.contenitore = sezione.querySelector('product-form');
        this.form = this.contenitore?.querySelector('form');
        if (!this.form) return;

        this.avviso = this.querySelector('[data-avviso]');
        this.errore = this.querySelector('[data-errore]');

        this.contenitore.addEventListener('submit', this.intercetta.bind(this), true);
        this.addEventListener('change', this.aggiorna.bind(this));
        this.aggiorna();
      }

      /** Gli id delle varianti scelte, nell'ordine in cui compaiono. */
      get scelte() {
        return Array.from(this.querySelectorAll('[data-aggiunta]'))
          .map((e) => {
            // caselle e pulsanti contano solo da spuntati; la tendina conta sempre
            if (e.type === 'checkbox' || e.type === 'radio') return e.checked ? e.value : '';
            return e.value;
          })
          .filter(Boolean);
      }

      /** Quante ne vuole: le aggiunte seguono il prodotto, tre ciondoli tre catene. */
      get quantita() {
        const q = parseInt(this.form.querySelector('[name="quantity"]')?.value, 10);
        return Number.isFinite(q) && q > 0 ? q : 1;
      }

      aggiorna() {
        // la miniatura segue la tendina: si vede cosa si sta scegliendo
        const tendina = this.querySelector('select[data-aggiunta]');
        const foto = this.querySelector('[data-foto]');
        const scelta = tendina?.selectedOptions[0]?.dataset.foto;
        if (foto && scelta) foto.src = scelta;

        const attive = this.scelte.length > 0;
        if (this.avviso) this.avviso.hidden = !attive;
        // il pagamento rapido salta il carrello: con un'aggiunta va tolto
        document.documentElement.classList.toggle('con-aggiunte', attive);
        this.nascondiErrore();
      }

      mostraErrore(testo) {
        if (!this.errore) return;
        this.errore.textContent = testo;
        this.errore.hidden = false;
      }

      nascondiErrore() {
        if (this.errore) this.errore.hidden = true;
      }

      async intercetta(evt) {
        if (this.inCorso) return; // è il nostro stesso invio che ripassa di qui
        const scelte = this.scelte;
        if (!scelte.length) return;

        evt.preventDefault();
        evt.stopPropagation();

        const bottone = this.form.querySelector('[type="submit"]');
        bottone?.classList.add('loading');
        bottone?.querySelector('.loading__spinner')?.classList.remove('hidden');

        const quantity = this.quantita;
        try {
          const risposta = await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: scelte.map((id) => ({ id: Number(id), quantity })) }),
          });
          if (!risposta.ok) {
            const dati = await risposta.json().catch(() => ({}));
            throw new Error(dati.description || dati.message || 'carrello non raggiungibile');
          }
        } catch (e) {
          // se l'aggiunta non entra ci si ferma qui: meglio niente che un
          // carrello col ciondolo e senza la catena che si credeva di aver preso
          console.error(e);
          this.mostraErrore(`Non è stato possibile aggiungere: ${e.message}. Riprova.`);
          bottone?.classList.remove('loading');
          bottone?.querySelector('.loading__spinner')?.classList.add('hidden');
          return;
        }

        this.inCorso = true;
        this.form.requestSubmit();
        this.inCorso = false;
      }
    }
  );
}
